import { render, staticRenderFns } from "./AsientosSeleccionados.vue?vue&type=template&id=04a322cc"
import script from "./AsientosSeleccionados.vue?vue&type=script&lang=js"
export * from "./AsientosSeleccionados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports